const namespaceRegister = '[Register]';

export const REGISTER_SUCCESS = `${namespaceRegister} REGISTER_SUCCESS`;
export const REGISTER_FAILED = `${namespaceRegister} REGISTER_FAILED`;
export const REGISTER_RESET = `${namespaceRegister} REGISTER_RESET`;
